import { DropdownItem } from '@apeiron/common'
import { MenuItem, SelectChangeEvent, styled } from '@mui/material'
import { Select } from '@src/components/share/mui/Select'
import * as R from 'ramda'
import { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const SelectSection = styled(Select)`
  .MuiSelect-select {
    background-color: #161616;
  }

  max-height: 500px;

  ${props => props.theme.breakpoints.up('res480')} {
    min-width: 200px;
    min-height: 36px;
  }
  ${props => props.theme.breakpoints.down('res480')} {
    min-width: 140px;
    min-height: 42px;
  }
`

const Dropdown: FC<Props> = props => {
  const { className, items, value, onDropdownChange } = props

  const { t } = useTranslation()

  const handleOnChange = useCallback(
    (event: SelectChangeEvent<unknown>) => {
      if (onDropdownChange) {
        onDropdownChange(event.target.value as string)
      }
    },
    [onDropdownChange]
  )

  return (
    <SelectSection
      className={className}
      value={value}
      onChange={handleOnChange}
    >
      {R.map(
        item => (
          <MenuItem key={item.id} value={item.value}>
            {t(item.name)}
          </MenuItem>
        ),
        items
      )}
    </SelectSection>
  )
}

type Props = {
  className?: string
  items: DropdownItem[]
  value: string
  onDropdownChange?: (value: string) => void
}

export default Dropdown
